import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import ButtonCta from '@components/atoms/button-cta'
import Breadcrumbs from '@components/breadcrumbs'
import { useEffect, useState } from 'react'
import Link from 'next/link'
import useResizeObserver from '@hooks/useResizeObserver'
import { useStyles } from './hero-variant.styles'

const HeroVariant = (props) => {
  const {
    heroImage,
    heroImageMobile,
    breadcrumbsCollection,
    headline,
    subtitle,
    ctaHeadline,
    ctaButtonOne,
    ctaButtonTwo,
    ctaDescription,
    ctaLinkText,
    ctaLink,
    universityPage,
  } = props

  const [ref, entry] = useResizeObserver()
  const [offset, setOffset] = useState(0)

  const images = {
    sm: heroImageMobile?.url
      ? `${heroImageMobile.url}?fm=jpg&fl=progressive&q=80`
      : '',
    lg: heroImage?.url
      ? `${heroImage?.url}?fm=jpg&h=1200&w=1800&fit=fill&fl=progressive&q=80`
      : '',
  }

  const styles = useStyles({ images, offset })
  useEffect(() => {
    if (entry?.contentRect?.height) {
      setOffset(entry.contentRect.height / 2)
    }
  }, [entry?.contentRect?.height])

  return (
    <Box className={styles.root}>
      <Box className={styles.imageContainer} />
      <Box ref={ref} className={styles.heroBlock}>
        <Box className={styles.contentWrapper}>
          <Box className={styles.headlineContainer}>
            {breadcrumbsCollection?.items?.length > 0
            && (
              <Breadcrumbs component={Breadcrumbs} className={styles.breadcrumbs}>
                {breadcrumbsCollection.items.map((item) => {
                  return <Link key={item.buttonLabel} href={item.buttonLink || ''}>{item.buttonLabel}</Link>
                })}
              </Breadcrumbs>
            )}
            <Typography variant="h2" variantMapping={{ h2: 'h1' }} className={styles.headline}>{headline}</Typography>
            <Typography variant="body1">{subtitle}</Typography>
          </Box>
          <Box className={styles.ctaContainer}>
            <Box className={styles.ctaInnerContainer}>
              <Typography
                variant="h4"
                variantMapping={{ h4: 'h2' }}
                className={styles.ctaHeadline}
              >{ctaHeadline}
              </Typography>
              <Box className={styles.ctaButtonWrapper}>
                {ctaButtonOne?.length > 0 && (
                  <ButtonCta
                    className={!universityPage ? `${styles.active} ${styles.ctaButton}` : `${styles.ctaButton}`}
                    variant="outlined"
                    color="primary"
                    href={ctaButtonOne[1]}
                    dataAttrs={{ 'aria-label': `Navigate to ${ctaButtonOne[0]} page` }}
                  >
                    {ctaButtonOne[0]}
                  </ButtonCta>
                )}
                {ctaButtonTwo?.length > 0
                  && (
                    <ButtonCta
                      className={universityPage ? `${styles.active} ${styles.ctaButton}` : `${styles.ctaButton}`}
                      variant="outlined"
                      color="primary"
                      href={ctaButtonTwo[1]}
                      dataAttrs={{ 'aria-label': `Navigate to ${ctaButtonTwo[0]} page` }}
                    >
                      {ctaButtonTwo[0]}
                    </ButtonCta>
                  )}
              </Box>
              <Typography className={styles.ctaDescription} variant="body2">{ctaDescription}</Typography>
              <ButtonCta
                className={styles.ctaLink}
                href={ctaLink}
                variant="text"
                arrow
              >{ctaLinkText}
              </ButtonCta>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

HeroVariant.propTypes = {
  heroImage: PropTypes.object,
  heroImageMobile: PropTypes.object,
  breadcrumbsCollection: PropTypes.object,
  headline: PropTypes.string,
  subtitle: PropTypes.string,
  ctaHeadline: PropTypes.string,
  ctaButtonOne: PropTypes.array,
  ctaButtonTwo: PropTypes.array,
  ctaDescription: PropTypes.string,
  ctaLinkText: PropTypes.string,
  ctaLink: PropTypes.string,
  universityPage: PropTypes.bool,
}

export default HeroVariant
